import { render, staticRenderFns } from "./NoRealms.vue?vue&type=template&id=0d364103&"
import script from "./NoRealms.vue?vue&type=script&lang=js&"
export * from "./NoRealms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports